import { useMatches } from "src/router";

/** Route `handle` for an Ads page the product nav lists as a row of its own, so the Ads rail stays hidden beside it. */
export const ADS_RAIL_HIDDEN_BESIDE_PRODUCT_NAV_ROUTE_HANDLE = {
  adsRail: "hidden-beside-product-nav",
} as const;

export const useIsAdsRailHiddenBesideProductNav = () =>
  useMatches().some(
    ({ handle }) =>
      typeof handle === "object" &&
      handle !== null &&
      "adsRail" in handle &&
      handle.adsRail ===
        ADS_RAIL_HIDDEN_BESIDE_PRODUCT_NAV_ROUTE_HANDLE.adsRail,
  );
